import * as React from "react";
import { Tabs } from "../../bits/Tabs/Tabs";
import styles from "./OfficeManagement.module.scss";
import { defaultOffices } from "../../../../store/cache/location";
import { CacheContext } from "../../../../contexts/CacheContext";
import { AclContext } from "../../../../contexts/AclContext";
import { getOfficeManagers } from "../../../../store/cache/location";
import OfficeRequests from "../OfficeRequests/OfficeRequests";
import OfficeManagerActivitiesList from "../OfficeManagerActivitiesList/OfficeManagerActivitiesList";
import OfficeRequestWaitlist from "../OfficeRequestWaitlist/OfficeRequestWaitlist";
import AvailableOfficeWindows from "../AvailableOfficeWindows/AvailableOfficeWindows";
import DeleteOfficeWindowRequests from "../DeleteOfficeWindowRequests/DeleteOfficeWindowRequests";

export default function OfficeManagement() {
    const { offices: availableOffices = defaultOffices } = React.useContext(
        CacheContext
    ) || {
        offices: defaultOffices,
    };
    const [officeRequestCount, setOfficeRequestCount] = React.useState(0);
    const [officeWaitListCount, setOfficeWaitListCount] = React.useState(0);
    const [officeDeleteRequestCount, setOfficeDeleteRequestCount] =
        React.useState(0);
    const loggedInUserEmail = React.useContext(AclContext)?.authUser.user?.email;
    const pageLimit = 50;
    const [officeManagerLocations, setOfficeManagerLocations] =
        React.useState<string[]>();
    const getOfficeManagerLocations = async () => {
        const getOfficeManager = await getOfficeManagers();
        const officeManagerLocationsofLoggedInUser = Object.keys(
            getOfficeManager || {}
        )?.filter((location) => {
            return (
                getOfficeManager &&
                getOfficeManager[location]?.includes(loggedInUserEmail as string)
            );
        });
        return officeManagerLocationsofLoggedInUser;
    };

    React.useEffect(() => {
        const getLocations = async () => {
            const locations = await getOfficeManagerLocations();
            setOfficeManagerLocations(locations);
        };
        getLocations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // filteredOffices for logged in OfficeManagers
    const filteredOffices = Object.entries(availableOffices)
        .filter(
            ([location]) =>
                officeManagerLocations && officeManagerLocations.includes(location)
        )
        .reduce((acc, [location, offices]) => {
            acc[location] = offices;
            return acc;
        }, {});

    const tabItems = [
        {
            key: "office-requests",
            label: "Office Window Requests",
            children: (
                <OfficeRequests
                    setOfficeRequestCount={setOfficeRequestCount}
                    officeManagerLocations={officeManagerLocations}
                    filteredOffices={filteredOffices}
                />
            ),
            count:
                officeRequestCount > 0
                    ? officeRequestCount >= pageLimit
                        ? `${pageLimit}+`
                        : officeRequestCount
                    : undefined,
        },
        {
            key: "waitlist-requests",
            label: "Waitlist Requests",
            children: (
                <OfficeRequestWaitlist
                    setOfficeWaitListCount={setOfficeWaitListCount}
                    officeManagerLocations={officeManagerLocations}
                    filteredOffices={filteredOffices}
                />
            ),
            count:
                officeWaitListCount > 0
                    ? officeWaitListCount >= pageLimit
                        ? `${pageLimit}+`
                        : officeWaitListCount
                    : undefined,
        },
        {
            key: "delete-office-window-requests",
            label: "Delete Office Window Requests",
            children: (
                <DeleteOfficeWindowRequests
                    setOfficeDeleteRequestCount={setOfficeDeleteRequestCount}
                    officeManagerLocations={officeManagerLocations}
                    filteredOffices={filteredOffices}
                />
            ),
            count:
                officeDeleteRequestCount > 0
                    ? officeDeleteRequestCount >= pageLimit
                        ? `${pageLimit}+`
                        : officeDeleteRequestCount
                    : undefined,
        },
        {
            key: "available-windows",
            label: "Set Available Office Windows",
            children: (
                <AvailableOfficeWindows
                    officeManagerLocations={officeManagerLocations}
                    filteredOffices={filteredOffices}
                />
            ),
        },
        {
            key: "request-activities",
            label: "Activities",
            children: (
                <OfficeManagerActivitiesList
                    officeManagerLocations={officeManagerLocations}
                    filteredOffices={filteredOffices}
                />
            ),
        },
    ];
    return (
        <div className="v2-page">
            <Tabs items={tabItems} className={styles.tabs} />
        </div>
    );
}
